import React, {Component} from "react";
import {observer} from "mobx-react";
import {Web3Store} from "../stores/web3Store";
import {RootStore} from "../stores/rootStore";
import logger from "../logger";
import BackToPreviousPage from "../components/backPreviousPage";
import "../styles/IPLManagement.less";
import {ILicensedNFT, IMythServerResponse, IPagination} from "../bean/ResponseBean";
import {LicensedNFTStatus, MythServerResultCode} from "../constant/CommonConstant";
import {Tabs, Table, Button, Tooltip, Modal} from "antd";
import type {ColumnsType} from 'antd/es/table';
import {MythPagination} from "../components/pagination";
import {PageLoader} from "../components/pageLoader";
import {QuestionCircleFilled, CloseCircleFilled, CheckCircleFilled, ClockCircleFilled} from "@ant-design/icons";
import {getRoutePath, MythRouteId} from "../router-config";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {IPLInfo} from "../bean/RequestBean";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}

interface IStates {
    licenseList: ILicensedNFT[],
    totalNum: number,
    totalPage: number,
    pageNum: number,
    loading: boolean,
    searchStatus: number[],
}

@observer
class IPLManagement extends Component<IProps, IStates> {
    private firstRequest: boolean = true;
    private pageSize: number = 10;
    private deleteStates: Map<number, boolean> = new Map();

    constructor(props: IProps, state: IStates) {
        super(props);
        this.state = {
            licenseList: [],
            totalNum: 0,
            totalPage: 1,
            pageNum: 1,
            loading: true,
            searchStatus: [LicensedNFTStatus.ISSUED.valueOf(),
                LicensedNFTStatus.PENDING.valueOf(), LicensedNFTStatus.REJECT.valueOf(), LicensedNFTStatus.OVERDUE.valueOf()]
        }
    }

    getLicensedList = async () => {
        const {web3Store} = this.props;
        const {pageNum, searchStatus} = this.state;
        try {
            if (web3Store.mythServerApi && web3Store.account) {
                const result: IMythServerResponse<IPagination<ILicensedNFT>> = await web3Store.mythServerApi.getMyIPLs(searchStatus, web3Store.account, pageNum, this.pageSize);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.firstRequest = false;
                        this.setState({
                            licenseList: data.dataList,
                            totalNum: data.totalNum,
                            totalPage: data.totalPage,
                            loading: false
                        });
                    }
                }
            }
        } catch (ex: any) {
            logger.error(ex);
        }
    };
    onChangePage = (pageNo: number) => {
        this.setState({pageNum: pageNo}, () => {
            this.getLicensedList();
        })
    }

    onUpdateClick = (ipId: number, nftImage: string,collectionName:string) => {
        console.log(this)
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.IPLEdit),
            state: {
                ipId: ipId,
                nftImage: nftImage,
                collectionName:collectionName
            }
        })
    }
    onDeleteClick = async (ipId: number) => {
        const {web3Store} = this.props
        try {
            if (web3Store.mythServerApi && web3Store.account) {
                this.deleteStates.set(ipId, true);
                this.forceUpdate()
                const result: IMythServerResponse<Boolean> = await web3Store.mythServerApi.deleteIPL(web3Store.account, ipId);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    this.deleteStates.set(ipId, false);
                    Modal.success({
                        content: 'Operation succeeded',
                        onOk: args => {
                            window.location.reload()
                        }
                    });
                } else {
                    this.deleteStates.set(ipId, false);
                    this.forceUpdate()
                }

            }
        } catch (ex: any) {
            logger.error(ex);
            this.deleteStates.set(ipId, true);
            this.forceUpdate()
        }

    }

    private columns: ColumnsType<ILicensedNFT> = [
        {
            title: 'Collection',
            dataIndex: '',
            key: 'collection',
            align: "left",
            render: (_, row) => <div className="ipl-collection flex-row">
                <img className="collection-logo" src={row.licenseCollectionLogo} alt=""/>
                <div>
                    <div className="collection-name">{row.licenseCollectionName}</div>
                    <small>vividLimited</small>
                </div>
            </div>,
        },
        {
            title: 'Shelf Price',
            dataIndex: 'price',
            key: 'price',
            align: "center",
        },
        {
            title: 'Issue Quantity',
            dataIndex: 'totalSupply',
            key: 'totalSupply',
            align: "center",
        },
        {
            title: <Tooltip placement="top" title="tips" arrowPointAtCenter>
                <span className="validity-ti tip">Licensing validity<QuestionCircleFilled style={{color: "#000"}}/></span>
            </Tooltip>,
            dataIndex: 'licensingPeriod',
            key: 'licensingPeriod',
            align: "center",
            render: (text) => <span>{text} days</span>
        },
        {
            title: 'Issue Status',
            dataIndex: 'status',
            key: 'status',
            align: "center",
            render: (_, row) => {
                switch (row.status) {
                    case LicensedNFTStatus.ISSUED:
                        return <small className="issue-tag issue-success"><CheckCircleFilled/> Success</small>;
                    case LicensedNFTStatus.PENDING:
                        return <small className="issue-tag issue-pending"><ClockCircleFilled/> Pending</small>;
                    case LicensedNFTStatus.REJECT:
                        return <small className="issue-tag issue-reject"><CloseCircleFilled/> Reject</small>;
                    case LicensedNFTStatus.OVERDUE:
                        return <small className="issue-tag issue-reject"><CloseCircleFilled/> Overdue</small>;
                    default:
                        return "";
                }
            },
        },
        {
            title: 'Operate',
            dataIndex: 'Operate',
            key: 'Operate',
            align: "center",
            render: (_, row) => (
                row.status === LicensedNFTStatus.PENDING ?
                    <Button className="myth-button" onClick={event => {
                        this.onUpdateClick(row.ipId, row.licensedNFTImage,row.licenseCollectionName)
                    }}>Edit</Button> :
                    row.status === LicensedNFTStatus.ISSUED ?
                        <Button className="myth-button bg-gray" loading={this.deleteStates.get(row.ipId)}
                                onClick={event => {
                                    this.onDeleteClick(row.ipId)
                                }}>下架</Button> :
                        <Button className="myth-button bg-gray" onClick={event => {
                            this.onUpdateClick(row.ipId, row.licensedNFTImage,row.licenseCollectionName)
                        }}>重新上架</Button>

            ),
        },
    ];
    changeTab = (activeKey: string) => {
        let searchStatus: number[] = [];
        if (activeKey === "all") {
            searchStatus = [LicensedNFTStatus.ISSUED.valueOf(),
                LicensedNFTStatus.PENDING.valueOf(), LicensedNFTStatus.REJECT.valueOf(), LicensedNFTStatus.OVERDUE.valueOf()];
        }
        if (activeKey === "listing") {
            searchStatus = [LicensedNFTStatus.ISSUED.valueOf()];
        }
        if (activeKey === "pending") {
            searchStatus = [LicensedNFTStatus.PENDING.valueOf()];
        }
        if (activeKey === "reject") {
            searchStatus = [LicensedNFTStatus.REJECT.valueOf()];
        }
        this.setState({
            searchStatus: searchStatus,
            pageNum: 1,
            loading: true
        }, this.getLicensedList)
    }

    render() {
        const {totalPage, totalNum, pageNum, licenseList, loading} = this.state;
        const {TabPane} = Tabs;

        if (this.firstRequest) {
            this.getLicensedList()
        }
        return <div className="ipl-management-container">
            <BackToPreviousPage/>
            <div className="list-title">IP Licensing Card Management</div>
            <Tabs defaultActiveKey="1" className="myth-tabs" onChange={this.changeTab}>
                <TabPane tab="All" key="all"></TabPane>
                <TabPane tab="Listing" key="listing"></TabPane>
                <TabPane tab="Pending" key="pending"></TabPane>
                <TabPane tab="Reject" key="reject"></TabPane>
            </Tabs>
            {loading ? <PageLoader/> :
                <div className="myth-panel">
                    <Table className="ipl-table" rowKey={(row) => row.ipId} columns={this.columns}
                           dataSource={licenseList} pagination={false}/>
                    <MythPagination totalPage={totalPage} total={totalNum} showTotal={true}
                                    currentPage={pageNum} pageSize={this.pageSize}
                                    onChange={(pageNo: number) => this.onChangePage(pageNo)}/>
                </div>
            }
        </div>
    }
}

export default withRouter(IPLManagement);
